import { z } from 'zod';
/** What a field mapping does to a source value before it is written. */
export var FeedFieldMappingOperation;
(function (FeedFieldMappingOperation) {
    FeedFieldMappingOperation["Constant"] = "CONSTANT";
    FeedFieldMappingOperation["Date"] = "DATE";
    FeedFieldMappingOperation["Datetime"] = "DATETIME";
    FeedFieldMappingOperation["Language"] = "LANGUAGE";
    FeedFieldMappingOperation["AddLeadingZeroes"] = "ADD_LEADING_ZEROES";
    FeedFieldMappingOperation["StripLeadingZeroes"] = "STRIP_LEADING_ZEROES";
    FeedFieldMappingOperation["Lowercase"] = "LOWERCASE";
    FeedFieldMappingOperation["Pascalcase"] = "PASCALCASE";
    FeedFieldMappingOperation["Sex"] = "SEX";
    FeedFieldMappingOperation["Uppercase"] = "UPPERCASE";
    FeedFieldMappingOperation["EpicDiagnosis"] = "EPIC_DIAGNOSIS";
    FeedFieldMappingOperation["Mapping"] = "MAPPING";
})(FeedFieldMappingOperation || (FeedFieldMappingOperation = {}));
export const FeedFieldMappingOperationSchema = z.enum(FeedFieldMappingOperation);
const parameterless = [
    FeedFieldMappingOperation.Language,
    FeedFieldMappingOperation.StripLeadingZeroes,
    FeedFieldMappingOperation.Lowercase,
    FeedFieldMappingOperation.Pascalcase,
    FeedFieldMappingOperation.Sex,
    FeedFieldMappingOperation.Uppercase,
    FeedFieldMappingOperation.EpicDiagnosis,
];
/**
 * A transform on the way in. Each operation carries exactly the parameters it needs, and the rest
 * carry none.
 *
 * `MAPPING` is absent by design: the operation exists in the stored transform, but the route has
 * never accepted one, so publishing it would advertise a body the server rejects.
 */
export const FeedFieldMappingTransformSchema = z.discriminatedUnion('operation', [
    z
        .object({
        operation: z.literal(FeedFieldMappingOperation.Constant),
        // The empty string is a legitimate constant: it blanks the target column.
        value: z.string(),
    })
        .strict(),
    z
        .object({
        operation: z.literal(FeedFieldMappingOperation.Date),
        format: z.string().min(1),
    })
        .strict(),
    z
        .object({
        operation: z.literal(FeedFieldMappingOperation.Datetime),
        format: z.string().min(1),
    })
        .strict(),
    z
        .object({
        operation: z.literal(FeedFieldMappingOperation.AddLeadingZeroes),
        totalCharacters: z.number(),
    })
        .strict(),
    ...parameterless.map((operation) => z.object({ operation: z.literal(operation) }).strict()),
]);
/**
 * One mapping: the feed column, the model column it binds to, and an optional transform between.
 *
 * `dataBinding` is a `table.column` pair the server offers for the feed's job kind. The set is
 * built from primary's table definitions, so it is checked where those are known rather than here.
 */
export const FeedFieldMappingUpsertSchema = z
    .object({
    field: z.string().min(1),
    dataBinding: z.string().min(1),
    transform: FeedFieldMappingTransformSchema.nullable().optional(),
})
    .strict();
/** The whole set is sent at once: a mapping missing from the body is a mapping removed. */
export const FeedFieldMappingBulkUpsertSchema = z.array(FeedFieldMappingUpsertSchema);
//# sourceMappingURL=fieldMapping.js.map